import 'bootstrap/dist/css/bootstrap.min.css';

import React, { Component } from 'react';
import IdleTimer from 'react-idle-timer';
import API from './API';
import './App.css';
import home from './home.svg';
import logo from './logo.png';
import ResultsTable2 from './ResultsTable2';
import EventListing from './EventListing';

import GridExample from './GridExample';


class App extends Component {
  constructor(props) {
    super(props);
	
	document.title = "events360 Race results";

    this.api = new API();
    this.idleTimeout = 30 * 60 * 1000;
	
    this.state = {
		event_id: null,
		club: '',
		category: '',
		time: Date.now(),
		competitors: [],
		checkpoints: [],
		myevent: null,
		page: "-1",
		rotatePages: "N",
		numPages: 0,
		competitor_event_results: [],
		defaultColDef: { sortable: true, width: 150},
		sortorder:  [{
        "id": "positionIndex",
        "desc": false
		}]
    };
	
	const searchParams = new URLSearchParams(window.location.search);
	this.state.event_id = searchParams.get('event_id');
	this.state.club = searchParams.get('club');
	this.state.category = searchParams.get('cat');
	
	if (searchParams.get('page') != "")
	{
		this.state.rotatePages = searchParams.get('page');
	}
  }
  
 
	componentDidMount() {
		
		if (this.state.event_id != null && this.state.event_id != "")
		{
			this.loadData();
			let theApp = this;
			if (theApp.state.myevent == null)
			{
				this.api.getevent(this.state.event_id, function done(data) {
				if (data)
					{
						theApp.setState({myevent : data})
					}
				}, function notFound() {
					// not found
					console.log('not found');
				}, function fail(xhr) {
					console.log(xhr);
					//onFail();
				});
			}
		this.getData();

			this.interval = setInterval(() => this.getData(), 10000);
		}
    }
	
	componentWillUnmount() {
		clearInterval(this.interval);
	}
	

	
  
  getData()
  {
	  let theApp = this;
	  
	  	this.api.checkpoints(this.state, function done(data) {
	  if (data) {
		  theApp.state.checkpoints = data;
			//theApp.state.checkpoints.push(data)
		//theApp.state.competitor_event_results_full.push(data)
	  }
	}, function notFound() {
	  // not found
		console.log('not found');
	}, function fail(xhr) {
	  console.log(xhr);
	  //onFail();
	});

	if (this.state.club != null)
	{
		  this.api.resultsbyclub(this.state, function done(data) {
		  if (data) {
			  theApp.setState(
				theApp.state.competitor_event_results = data
				)
				theApp.state.numPages = (data.length / 100);
		  }
		}, function notFound() {
		  // not found
			console.log('not found');
		}, function fail(xhr) {
		  console.log(xhr);
		  //onFail();
		});
	}
	else if (this.state.category != null)
	{
		  this.api.resultsbycategory(this.state, function done(data) {
		  if (data) {
			  theApp.setState(
				theApp.state.competitor_event_results = data
				)
				theApp.state.numPages = (data.length / 100);
		  }
		}, function notFound() {
		  // not found
			console.log('not found');
		}, function fail(xhr) {
		  console.log(xhr);
		  //onFail();
		});
	}
	else
	{
		  this.api.results(this.state, function done(data) {
		  if (data) {
			  theApp.setState(
				theApp.state.competitor_event_results = data
				)
				theApp.state.numPages = (data.length / 100);
		  }
		}, function notFound() {
		  // not found
			console.log('not found');
		}, function fail(xhr) {
		  console.log(xhr);
		  //onFail();
		});
	}
	
	if (this.state.rotatePages == "Y")
	{
		if (this.state.page < (this.state.numPages-1))
		{
			this.state.page = this.state.page + 1;
		}
		else
		{
			this.state.page = 0;
		}
	}
  }
  
    loadData() {
		let theApp = this;
    }

  render() {
	  
	  if (this.state.event_id == null || this.state.event_id == "")
	  {
		  return (
      <IdleTimer
        ref="idleTimer"
        element={document}
        idleAction={() => this.startAgain()}
        timeout={this.idleTimeout}
        format="MM-DD-YYYY HH:MM:ss.SSS">
        <div className="App">
          <div className="App-header">
            <a className="App-home" href="/" onClick={(e) => this.startAgain(e)}>
              <img src={home} alt="[Home]"/>
            </a>
            <img src={logo} alt="Events360" className="App-logo"/>
          </div>
          <div className="App-body">
			<EventListing />
          </div>
        </div>
      </IdleTimer>
						  )
	  }
	  else
	  {

	  if (this.state.myevent == null) {
            return (
      <IdleTimer
        ref="idleTimer"
        element={document}
        idleAction={() => this.startAgain()}
        timeout={this.idleTimeout}
        format="MM-DD-YYYY HH:MM:ss.SSS">
        <div className="App">
          <div className="App-header">
            <a className="App-home" href="/" onClick={(e) => this.startAgain(e)}>
              <img src={home} alt="[Home]"/>
            </a>
            <img src={logo} alt="Events360" className="App-logo"/>
          </div>
          <div className="App-body">
			<h1>No event found</h1>
          </div>
        </div>
      </IdleTimer>
				
			)
        }
    return (
      <IdleTimer
        ref="idleTimer"
        element={document}
        idleAction={() => this.startAgain()}
        timeout={this.idleTimeout}
        format="MM-DD-YYYY HH:MM:ss.SSS">
        <div className="App">
          <div className="App-header">
            <a className="App-home" href="/" onClick={(e) => this.startAgain(e)}>
              <img src={home} alt="[Home]"/>
            </a>
            <img src={logo} alt="Events360" className="App-logo"/>
          </div>
          <div className="App-body">
			{this.screen()}
          </div>
        </div>
      </IdleTimer>
    );
	  }
  }

  screen() {
	  //this.interval = setInterval(() => this.getData(), 10000);
    return <ResultsTable2 theevent={this.state.myevent} checkpoints={this.state.checkpoints} results={this.state.competitor_event_results} sortorder={this.state.sortorder}  defaultColDef={this.state.defaultColDef} page={this.state.page} />
	//return <GridExample />;
  }
  
}

export default App;

